import { ContractEventType } from '@einstein-moving/shared-types'
import * as yup from 'yup'

export { ContractEventType }

export enum MilestoneType {
  CREATED = 1,
  RFQ_SENT = 20,
  FIRST_CALL = 30,
  SECOND_CALL = 40,
  BOOKED = 50,
  CONFIRMATION_CALL = 60,
  CLOSED = 100,
}

export interface ContractEvent {
  type: ContractEventType
  timestamp: Date
  employeeId: string
  contractId: string
  request: {
    method: string
    url: string
    statusCode: number
    body?: object
  }
  data: any
  milestone?: MilestoneType
}

// below are event specific interfaces to use for
// respective event types
export interface IPhoneEventData {
  contractId: string
  phone: string
  isVoiceMail: boolean
  isSms: boolean
  notes: string
}

export const PhoneEventDataValidationSchema = yup.object().shape({
  contractId: yup.string().matches(/^[a-f\d]{24}$/i, { excludeEmptyString: true }),
  phone: yup.string().required(),
  isVoiceMail: yup.boolean(),
  isSms: yup.boolean(),
  notes: yup.string().required(),
})
